import { Accordion, AccordionItem } from '@heroui/react';
import React, { FC } from 'react';
import { useLanguageState } from 'src/state';
import { FaqFirestoreResponse } from 'src/types';

import { Error, Flex, Spinner, Title } from '..';

interface FaqsProps {
    faqs?: FaqFirestoreResponse[];
    isLoading: boolean;
    isError: boolean;
}
export const Faqs: FC<FaqsProps> = ({ faqs, isLoading, isError }) => {
  const { language: currentLang } = useLanguageState();

  if (isLoading) {
    return <Spinner global />;
  }
  return (
    <>
      {isError && <Error errorMessage="Error loading FAQ data, please try again...." />}
      {faqs && faqs?.length > 0 ? (
        <Flex direction="column" flexWrap="nowrap" margin="10px 0">
          <Title icon="" title="FAQ" />
          <Accordion>
            {faqs?.map((faq) => (
              <AccordionItem
                key={faq.id}
                aria-label="Informacje hotelowe"
                title={faq.title[currentLang]}
              >
                {faq.description[currentLang]}
              </AccordionItem>
            )) ?? []}
          </Accordion>
        </Flex>
      ) : null}
    </>
  );
};
